var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubjecticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.612,
    height: 16.145,
    viewBox: "0 0 17.612 16.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "title",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3175",
    "data-name": "Group 3175",
    transform: "translate(11.008 6.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5846",
    "data-name": "Path 5846",
    d: "M18.853,10.1h-3.3a.55.55,0,0,1,0-1.1h3.3a.55.55,0,1,1,0,1.1Z",
    transform: "translate(-15 -9)",
    fill: "rgba(248,225,247,0.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3176",
    "data-name": "Group 3176",
    transform: "translate(11.008 9.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5847",
    "data-name": "Path 5847",
    d: "M18.853,14.1h-3.3a.55.55,0,0,1,0-1.1h3.3a.55.55,0,1,1,0,1.1Z",
    transform: "translate(-15 -13)",
    fill: "rgba(248,225,247,0.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3177",
    "data-name": "Group 3177",
    transform: "translate(11.008 12.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5848",
    "data-name": "Path 5848",
    d: "M18.853,18.1h-3.3a.55.55,0,0,1,0-1.1h3.3a.55.55,0,1,1,0,1.1Z",
    transform: "translate(-15 -17)",
    fill: "rgba(248,225,247,0.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3178",
    "data-name": "Group 3178",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5849",
    "data-name": "Path 5849",
    d: "M15.594,17.145H2.018A2.02,2.02,0,0,1,0,15.127V3.018A2.02,2.02,0,0,1,2.018,1H15.594a2.02,2.02,0,0,1,2.018,2.018V15.127A2.02,2.02,0,0,1,15.594,17.145ZM2.018,2.1a.919.919,0,0,0-.917.917V15.127a.919.919,0,0,0,.917.917H15.594a.919.919,0,0,0,.917-.917V3.018a.919.919,0,0,0-.917-.917Z",
    transform: "translate(0 -1)",
    fill: "rgba(248,225,247,0.25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3179",
    "data-name": "Group 3179",
    transform: "translate(0 3.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5850",
    "data-name": "Path 5850",
    d: "M17.062,5.6H.55a.55.55,0,0,1,0-1.1H17.062a.55.55,0,0,1,0,1.1Z",
    transform: "translate(0 -4.5)",
    fill: "rgba(248,225,247,0.25)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(2.538 11.673)",
    fill: "rgba(248,225,247,0.25)",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubjecticon);
export default __webpack_public_path__ + "static/media/subject icon.5de55576993b97ab290da91f8183ec4c.svg";
export { ForwardRef as ReactComponent };